import { useFormState } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import Button from '../../../packages/kiti/components/actions/Button'
import Input from '../../../components/form/Input'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import useRequestPassword from './_requests/requestPassword'

const ForgotPasswordForm = () => {
  const { t } = useTranslation('session')
  const [form, handleChange] = useFormState({
    email: ''
  })

  const [handleRequest, { loading }] = useRequestPassword(form.email)

  return (
    <form onSubmit={handleRequest}>
      <Title size="h3">{t('forgotPasswordForm.forgotPassword')}</Title>

      <Separator weight={4} />

      <Input type="email" placeholder={t('email')} value={form.email} onChange={handleChange('email')} />

      <Separator weight={4} />

      <Button type="submit" fullWidth loading={loading} bgColor="dark1">
        {t('forgotPasswordForm.requestNewPassword')}
      </Button>
    </form>
  )
}

export default ForgotPasswordForm
